import * as React from 'react';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';
import useSortSelect from '../../hooks/useSortSelect';
import MdcSelect from '../../../select/MdcSelect';

interface ISidebarSortProps {
    sortParamNames: string[];
    currentSortParam: string;

    dispatch: React.Dispatch<any>;
}

const SortSelectComponent: React.FunctionComponent<ISidebarSortProps> = props => {
    const { sortParamNames, currentSortParam, dispatch } = props;

    const [sortSelectOptions, onSortSelect] = useSortSelect(sortParamNames, dispatch);

    return (
        <MdcSelect
            selectedValue={currentSortParam}
            options={sortSelectOptions}
            onChange={onSortSelect}
        />
    );
};

const SortSelect = withMemo(SortSelectComponent);

export default SortSelect;
